import React, { useEffect, useState, useRef, createElement } from 'react';
import { motion } from 'framer-motion';
import { Loader2Icon } from 'lucide-react';
export const Hero = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const videoRef = useRef(null);
  // Preload the video when component mounts
  useEffect(() => {
    // Create a new video element for preloading
    const preloadVideo = document.createElement('video');
    // Set up event listeners for the preload video
    preloadVideo.addEventListener('canplaythrough', () => {
      // Once preloaded video can play through, update our actual video element
      if (videoRef.current) {
        videoRef.current.src = preloadVideo.src;
        setIsVideoLoaded(true);
        setIsLoading(false);
      }
    });
    preloadVideo.addEventListener('error', handleVideoError);
    // Start loading the video
    preloadVideo.src = 'https://media.githubusercontent.com/media/DanteMagg/danyi-video-storage/main/RPReplay_Final1725233440%202.mov';
    preloadVideo.load();
    // Cleanup
    return () => {
      preloadVideo.removeEventListener('canplaythrough', () => {});
      preloadVideo.removeEventListener('error', handleVideoError);
    };
  }, []);
  const handleVideoError = () => {
    setIsLoading(false);
    // In case of error, we still want to show something
    setIsVideoLoaded(false);
  };
  return <section className="relative w-full h-[90vh] bg-gray-900" data-id="element-484">
      <div className="absolute inset-0 overflow-hidden" data-id="element-485">
        {/* Loading indicator */}
        {isLoading && <div className="absolute inset-0 flex items-center justify-center bg-gray-900" data-id="element-486">
            <Loader2Icon className="w-12 h-12 text-white animate-spin" data-id="element-487" />
          </div>}
        {/* Video background */}
        <video ref={videoRef} className={`absolute w-full h-full object-cover transition-opacity duration-500 ${isVideoLoaded ? 'opacity-100' : 'opacity-0'}`} autoPlay loop muted playsInline data-id="element-488">
          <source type="video/mp4" data-id="element-489" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-490"></div>
      </div>
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-center items-center text-center" data-id="element-491">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl md:text-5xl lg:text-6xl font-normal text-white max-w-2xl leading-tight" data-id="element-492">
          Find your dream home today
        </motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-6 text-xl text-white max-w-xl" data-id="element-493">
          Expert real estate services for luxury listings
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-8" data-id="element-494">
          <motion.a href="#" className="bg-[#3a4a56] hover:bg-[#2a3a46] text-white px-8 py-4 rounded-md font-medium transition duration-200 inline-block text-lg" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-495">
            Explore Listings
          </motion.a>
        </motion.div>
      </div>
    </section>;
};